export const countryCodes = [
  {
    "callingCode": "1",
    "code": "US",
    "name": "United States",
  },
  {
    "callingCode": "1",
    "code": "CA",
    "name": "Canada",
  },
  {
    "callingCode": "33",
    "code": "FR",
    "name": "France",
  },
  {
    "callingCode": "49",
    "code": "DE",
    "name": "Germany",
  },
  {
    "callingCode": "297",
    "code": "AW",
    "name": "Aruba",
  },
  {
    "callingCode": "93",
    "code": "AF",
    "name": "Afghanistan",
  },
  {
    "callingCode": "244",
    "code": "AO",
    "name": "Angola",
  },
  {
    "callingCode": "1264",
    "code": "AI",
    "name": "Anguilla",
  },
  {
    "callingCode": "358",
    "code": "AX",
    "name": "Åland Islands",
  },
  {
    "callingCode": "355",
    "code": "AL",
    "name": "Albania",
  },
  {
    "callingCode": "376",
    "code": "AD",
    "name": "Andorra",
  },
  {
    "callingCode": "971",
    "code": "AE",
    "name": "United Arab Emirates",
  },
  {
    "callingCode": "54",
    "code": "AR",
    "name": "Argentina",
  },
  {
    "callingCode": "374",
    "code": "AM",
    "name": "Armenia",
  },
  {
    "callingCode": "1684",
    "code": "AS",
    "name": "American Samoa",
  },
  {
    "callingCode": "1268",
    "code": "AG",
    "name": "Antigua and Barbuda",
  },
  {
    "callingCode": "61",
    "code": "AU",
    "name": "Australia",
  },
  {
    "callingCode": "43",
    "code": "AT",
    "name": "Austria",
  },
  {
    "callingCode": "994",
    "code": "AZ",
    "name": "Azerbaijan",
  },
  {
    "callingCode": "257",
    "code": "BI",
    "name": "Burundi",
  },
  {
    "callingCode": "32",
    "code": "BE",
    "name": "Belgium",
  },
  {
    "callingCode": "229",
    "code": "BJ",
    "name": "Benin",
  },
  {
    "callingCode": "226",
    "code": "BF",
    "name": "Burkina Faso",
  },
  {
    "callingCode": "880",
    "code": "BD",
    "name": "Bangladesh",
  },
  {
    "callingCode": "359",
    "code": "BG",
    "name": "Bulgaria",
  },
  {
    "callingCode": "973",
    "code": "BH",
    "name": "Bahrain",
  },
  {
    "callingCode": "1242",
    "code": "BS",
    "name": "Bahamas",
  },
  {
    "callingCode": "387",
    "code": "BA",
    "name": "Bosnia and Herzegovina",
  },
  {
    "callingCode": "590",
    "code": "BL",
    "name": "Saint Barthélemy",
  },
  {
    "callingCode": "290",
    "code": "SH",
    "name": "Saint Helena, Ascension and Tristan da Cunha",
  },
  {
    "callingCode": "375",
    "code": "BY",
    "name": "Belarus",
  },
  {
    "callingCode": "501",
    "code": "BZ",
    "name": "Belize",
  },
  {
    "callingCode": "1441",
    "code": "BM",
    "name": "Bermuda",
  },
  {
    "callingCode": "591",
    "code": "BO",
    "name": "Bolivia",
  },
  {
    "callingCode": "599",
    "code": "BQ",
    "name": "Caribbean Netherlands",
  },
  {
    "callingCode": "55",
    "code": "BR",
    "name": "Brazil",
  },
  {
    "callingCode": "1246",
    "code": "BB",
    "name": "Barbados",
  },
  {
    "callingCode": "673",
    "code": "BN",
    "name": "Brunei",
  },
  {
    "callingCode": "975",
    "code": "BT",
    "name": "Bhutan",
  },
  {
    "callingCode": "267",
    "code": "BW",
    "name": "Botswana",
  },
  {
    "callingCode": "236",
    "code": "CF",
    "name": "Central African Republic",
  },
  {
    "callingCode": "61",
    "code": "CC",
    "name": "Cocos (Keeling) Islands",
  },
  {
    "callingCode": "41",
    "code": "CH",
    "name": "Switzerland",
  },
  {
    "callingCode": "56",
    "code": "CL",
    "name": "Chile",
  },
  {
    "callingCode": "86",
    "code": "CN",
    "name": "China",
  },
  {
    "callingCode": "225",
    "code": "CI",
    "name": "Ivory Coast",
  },
  {
    "callingCode": "237",
    "code": "CM",
    "name": "Cameroon",
  },
  {
    "callingCode": "243",
    "code": "CD",
    "name": "DR Congo",
  },
  {
    "callingCode": "242",
    "code": "CG",
    "name": "Republic of the Congo",
  },
  {
    "callingCode": "682",
    "code": "CK",
    "name": "Cook Islands",
  },
  {
    "callingCode": "57",
    "code": "CO",
    "name": "Colombia",
  },
  {
    "callingCode": "269",
    "code": "KM",
    "name": "Comoros",
  },
  {
    "callingCode": "238",
    "code": "CV",
    "name": "Cape Verde",
  },
  {
    "callingCode": "506",
    "code": "CR",
    "name": "Costa Rica",
  },
  {
    "callingCode": "53",
    "code": "CU",
    "name": "Cuba",
  },
  {
    "callingCode": "5999",
    "code": "CW",
    "name": "Curaçao",
  },
  {
    "callingCode": "61",
    "code": "CX",
    "name": "Christmas Island",
  },
  {
    "callingCode": "1345",
    "code": "KY",
    "name": "Cayman Islands",
  },
  {
    "callingCode": "357",
    "code": "CY",
    "name": "Cyprus",
  },
  {
    "callingCode": "420",
    "code": "CZ",
    "name": "Czechia",
  },
  {
    "callingCode": "253",
    "code": "DJ",
    "name": "Djibouti",
  },
  {
    "callingCode": "1767",
    "code": "DM",
    "name": "Dominica",
  },
  {
    "callingCode": "45",
    "code": "DK",
    "name": "Denmark",
  },
  {
    "callingCode": "1809",
    "code": "DO",
    "name": "Dominican Republic",
  },
  {
    "callingCode": "213",
    "code": "DZ",
    "name": "Algeria",
  },
  {
    "callingCode": "593",
    "code": "EC",
    "name": "Ecuador",
  },
  {
    "callingCode": "20",
    "code": "EG",
    "name": "Egypt",
  },
  {
    "callingCode": "291",
    "code": "ER",
    "name": "Eritrea",
  },
  {
    "callingCode": "212",
    "code": "EH",
    "name": "Western Sahara",
  },
  {
    "callingCode": "34",
    "code": "ES",
    "name": "Spain",
  },
  {
    "callingCode": "372",
    "code": "EE",
    "name": "Estonia",
  },
  {
    "callingCode": "251",
    "code": "ET",
    "name": "Ethiopia",
  },
  {
    "callingCode": "358",
    "code": "FI",
    "name": "Finland",
  },
  {
    "callingCode": "679",
    "code": "FJ",
    "name": "Fiji",
  },
  {
    "callingCode": "500",
    "code": "FK",
    "name": "Falkland Islands",
  },
  {
    "callingCode": "298",
    "code": "FO",
    "name": "Faroe Islands",
  },
  {
    "callingCode": "691",
    "code": "FM",
    "name": "Micronesia",
  },
  {
    "callingCode": "241",
    "code": "GA",
    "name": "Gabon",
  },
  {
    "callingCode": "44",
    "code": "GB",
    "name": "United Kingdom",
  },
  {
    "callingCode": "995",
    "code": "GE",
    "name": "Georgia",
  },
  {
    "callingCode": "44",
    "code": "GG",
    "name": "Guernsey",
  },
  {
    "callingCode": "233",
    "code": "GH",
    "name": "Ghana",
  },
  {
    "callingCode": "350",
    "code": "GI",
    "name": "Gibraltar",
  },
  {
    "callingCode": "224",
    "code": "GN",
    "name": "Guinea",
  },
  {
    "callingCode": "590",
    "code": "GP",
    "name": "Guadeloupe",
  },
  {
    "callingCode": "220",
    "code": "GM",
    "name": "Gambia",
  },
  {
    "callingCode": "245",
    "code": "GW",
    "name": "Guinea-Bissau",
  },
  {
    "callingCode": "240",
    "code": "GQ",
    "name": "Equatorial Guinea",
  },
  {
    "callingCode": "30",
    "code": "GR",
    "name": "Greece",
  },
  {
    "callingCode": "1473",
    "code": "GD",
    "name": "Grenada",
  },
  {
    "callingCode": "299",
    "code": "GL",
    "name": "Greenland",
  },
  {
    "callingCode": "502",
    "code": "GT",
    "name": "Guatemala",
  },
  {
    "callingCode": "594",
    "code": "GF",
    "name": "French Guiana",
  },
  {
    "callingCode": "1671",
    "code": "GU",
    "name": "Guam",
  },
  {
    "callingCode": "592",
    "code": "GY",
    "name": "Guyana",
  },
  {
    "callingCode": "852",
    "code": "HK",
    "name": "Hong Kong",
  },
  {
    "callingCode": "504",
    "code": "HN",
    "name": "Honduras",
  },
  {
    "callingCode": "385",
    "code": "HR",
    "name": "Croatia",
  },
  {
    "callingCode": "509",
    "code": "HT",
    "name": "Haiti",
  },
  {
    "callingCode": "36",
    "code": "HU",
    "name": "Hungary",
  },
  {
    "callingCode": "62",
    "code": "ID",
    "name": "Indonesia",
  },
  {
    "callingCode": "44",
    "code": "IM",
    "name": "Isle of Man",
  },
  {
    "callingCode": "91",
    "code": "IN",
    "name": "India",
  },
  {
    "callingCode": "246",
    "code": "IO",
    "name": "British Indian Ocean Territory",
  },
  {
    "callingCode": "353",
    "code": "IE",
    "name": "Ireland",
  },
  {
    "callingCode": "98",
    "code": "IR",
    "name": "Iran",
  },
  {
    "callingCode": "964",
    "code": "IQ",
    "name": "Iraq",
  },
  {
    "callingCode": "354",
    "code": "IS",
    "name": "Iceland",
  },
  {
    "callingCode": "972",
    "code": "IL",
    "name": "Israel",
  },
  {
    "callingCode": "39",
    "code": "IT",
    "name": "Italy",
  },
  {
    "callingCode": "1876",
    "code": "JM",
    "name": "Jamaica",
  },
  {
    "callingCode": "44",
    "code": "JE",
    "name": "Jersey",
  },
  {
    "callingCode": "962",
    "code": "JO",
    "name": "Jordan",
  },
  {
    "callingCode": "81",
    "code": "JP",
    "name": "Japan",
  },
  {
    "callingCode": "76",
    "code": "KZ",
    "name": "Kazakhstan",
  },
  {
    "callingCode": "254",
    "code": "KE",
    "name": "Kenya",
  },
  {
    "callingCode": "996",
    "code": "KG",
    "name": "Kyrgyzstan",
  },
  {
    "callingCode": "855",
    "code": "KH",
    "name": "Cambodia",
  },
  {
    "callingCode": "686",
    "code": "KI",
    "name": "Kiribati",
  },
  {
    "callingCode": "1869",
    "code": "KN",
    "name": "Saint Kitts and Nevis",
  },
  {
    "callingCode": "82",
    "code": "KR",
    "name": "South Korea",
  },
  {
    "callingCode": "383",
    "code": "XK",
    "name": "Kosovo",
  },
  {
    "callingCode": "965",
    "code": "KW",
    "name": "Kuwait",
  },
  {
    "callingCode": "856",
    "code": "LA",
    "name": "Laos",
  },
  {
    "callingCode": "961",
    "code": "LB",
    "name": "Lebanon",
  },
  {
    "callingCode": "231",
    "code": "LR",
    "name": "Liberia",
  },
  {
    "callingCode": "218",
    "code": "LY",
    "name": "Libya",
  },
  {
    "callingCode": "1758",
    "code": "LC",
    "name": "Saint Lucia",
  },
  {
    "callingCode": "423",
    "code": "LI",
    "name": "Liechtenstein",
  },
  {
    "callingCode": "94",
    "code": "LK",
    "name": "Sri Lanka",
  },
  {
    "callingCode": "266",
    "code": "LS",
    "name": "Lesotho",
  },
  {
    "callingCode": "370",
    "code": "LT",
    "name": "Lithuania",
  },
  {
    "callingCode": "352",
    "code": "LU",
    "name": "Luxembourg",
  },
  {
    "callingCode": "371",
    "code": "LV",
    "name": "Latvia",
  },
  {
    "callingCode": "853",
    "code": "MO",
    "name": "Macau",
  },
  {
    "callingCode": "590",
    "code": "MF",
    "name": "Saint Martin",
  },
  {
    "callingCode": "212",
    "code": "MA",
    "name": "Morocco",
  },
  {
    "callingCode": "377",
    "code": "MC",
    "name": "Monaco",
  },
  {
    "callingCode": "373",
    "code": "MD",
    "name": "Moldova",
  },
  {
    "callingCode": "261",
    "code": "MG",
    "name": "Madagascar",
  },
  {
    "callingCode": "960",
    "code": "MV",
    "name": "Maldives",
  },
  {
    "callingCode": "52",
    "code": "MX",
    "name": "Mexico",
  },
  {
    "callingCode": "692",
    "code": "MH",
    "name": "Marshall Islands",
  },
  {
    "callingCode": "389",
    "code": "MK",
    "name": "Macedonia",
  },
  {
    "callingCode": "223",
    "code": "ML",
    "name": "Mali",
  },
  {
    "callingCode": "356",
    "code": "MT",
    "name": "Malta",
  },
  {
    "callingCode": "95",
    "code": "MM",
    "name": "Myanmar",
  },
  {
    "callingCode": "382",
    "code": "ME",
    "name": "Montenegro",
  },
  {
    "callingCode": "976",
    "code": "MN",
    "name": "Mongolia",
  },
  {
    "callingCode": "1670",
    "code": "MP",
    "name": "Northern Mariana Islands",
  },
  {
    "callingCode": "258",
    "code": "MZ",
    "name": "Mozambique",
  },
  {
    "callingCode": "222",
    "code": "MR",
    "name": "Mauritania",
  },
  {
    "callingCode": "1664",
    "code": "MS",
    "name": "Montserrat",
  },
  {
    "callingCode": "596",
    "code": "MQ",
    "name": "Martinique",
  },
  {
    "callingCode": "230",
    "code": "MU",
    "name": "Mauritius",
  },
  {
    "callingCode": "265",
    "code": "MW",
    "name": "Malawi",
  },
  {
    "callingCode": "60",
    "code": "MY",
    "name": "Malaysia",
  },
  {
    "callingCode": "262",
    "code": "YT",
    "name": "Mayotte",
  },
  {
    "callingCode": "264",
    "code": "NA",
    "name": "Namibia",
  },
  {
    "callingCode": "687",
    "code": "NC",
    "name": "New Caledonia",
  },
  {
    "callingCode": "227",
    "code": "NE",
    "name": "Niger",
  },
  {
    "callingCode": "672",
    "code": "NF",
    "name": "Norfolk Island",
  },
  {
    "callingCode": "234",
    "code": "NG",
    "name": "Nigeria",
  },
  {
    "callingCode": "505",
    "code": "NI",
    "name": "Nicaragua",
  },
  {
    "callingCode": "683",
    "code": "NU",
    "name": "Niue",
  },
  {
    "callingCode": "31",
    "code": "NL",
    "name": "Netherlands",
  },
  {
    "callingCode": "47",
    "code": "NO",
    "name": "Norway",
  },
  {
    "callingCode": "977",
    "code": "NP",
    "name": "Nepal",
  },
  {
    "callingCode": "674",
    "code": "NR",
    "name": "Nauru",
  },
  {
    "callingCode": "64",
    "code": "NZ",
    "name": "New Zealand",
  },
  {
    "callingCode": "968",
    "code": "OM",
    "name": "Oman",
  },
  {
    "callingCode": "92",
    "code": "PK",
    "name": "Pakistan",
  },
  {
    "callingCode": "507",
    "code": "PA",
    "name": "Panama",
  },
  {
    "callingCode": "64",
    "code": "PN",
    "name": "Pitcairn Islands",
  },
  {
    "callingCode": "51",
    "code": "PE",
    "name": "Peru",
  },
  {
    "callingCode": "63",
    "code": "PH",
    "name": "Philippines",
  },
  {
    "callingCode": "680",
    "code": "PW",
    "name": "Palau",
  },
  {
    "callingCode": "675",
    "code": "PG",
    "name": "Papua New Guinea",
  },
  {
    "callingCode": "48",
    "code": "PL",
    "name": "Poland",
  },
  {
    "callingCode": "1787",
    "code": "PR",
    "name": "Puerto Rico",
  },
  {
    "callingCode": "850",
    "code": "KP",
    "name": "North Korea",
  },
  {
    "callingCode": "351",
    "code": "PT",
    "name": "Portugal",
  },
  {
    "callingCode": "595",
    "code": "PY",
    "name": "Paraguay",
  },
  {
    "callingCode": "970",
    "code": "PS",
    "name": "Palestine",
  },
  {
    "callingCode": "689",
    "code": "PF",
    "name": "French Polynesia",
  },
  {
    "callingCode": "974",
    "code": "QA",
    "name": "Qatar",
  },
  {
    "callingCode": "262",
    "code": "RE",
    "name": "Réunion",
  },
  {
    "callingCode": "40",
    "code": "RO",
    "name": "Romania",
  },
  {
    "callingCode": "7",
    "code": "RU",
    "name": "Russia",
  },
  {
    "callingCode": "250",
    "code": "RW",
    "name": "Rwanda",
  },
  {
    "callingCode": "966",
    "code": "SA",
    "name": "Saudi Arabia",
  },
  {
    "callingCode": "249",
    "code": "SD",
    "name": "Sudan",
  },
  {
    "callingCode": "221",
    "code": "SN",
    "name": "Senegal",
  },
  {
    "callingCode": "65",
    "code": "SG",
    "name": "Singapore",
  },
  {
    "callingCode": "500",
    "code": "GS",
    "name": "South Georgia",
  },
  {
    "callingCode": "4779",
    "code": "SJ",
    "name": "Svalbard and Jan Mayen",
  },
  {
    "callingCode": "677",
    "code": "SB",
    "name": "Solomon Islands",
  },
  {
    "callingCode": "232",
    "code": "SL",
    "name": "Sierra Leone",
  },
  {
    "callingCode": "503",
    "code": "SV",
    "name": "El Salvador",
  },
  {
    "callingCode": "378",
    "code": "SM",
    "name": "San Marino",
  },
  {
    "callingCode": "252",
    "code": "SO",
    "name": "Somalia",
  },
  {
    "callingCode": "508",
    "code": "PM",
    "name": "Saint Pierre and Miquelon",
  },
  {
    "callingCode": "381",
    "code": "RS",
    "name": "Serbia",
  },
  {
    "callingCode": "211",
    "code": "SS",
    "name": "South Sudan",
  },
  {
    "callingCode": "239",
    "code": "ST",
    "name": "São Tomé and Príncipe",
  },
  {
    "callingCode": "597",
    "code": "SR",
    "name": "Suriname",
  },
  {
    "callingCode": "421",
    "code": "SK",
    "name": "Slovakia",
  },
  {
    "callingCode": "386",
    "code": "SI",
    "name": "Slovenia",
  },
  {
    "callingCode": "46",
    "code": "SE",
    "name": "Sweden",
  },
  {
    "callingCode": "268",
    "code": "SZ",
    "name": "Swaziland",
  },
  {
    "callingCode": "1721",
    "code": "SX",
    "name": "Sint Maarten",
  },
  {
    "callingCode": "248",
    "code": "SC",
    "name": "Seychelles",
  },
  {
    "callingCode": "963",
    "code": "SY",
    "name": "Syria",
  },
  {
    "callingCode": "1649",
    "code": "TC",
    "name": "Turks and Caicos Islands",
  },
  {
    "callingCode": "235",
    "code": "TD",
    "name": "Chad",
  },
  {
    "callingCode": "228",
    "code": "TG",
    "name": "Togo",
  },
  {
    "callingCode": "66",
    "code": "TH",
    "name": "Thailand",
  },
  {
    "callingCode": "992",
    "code": "TJ",
    "name": "Tajikistan",
  },
  {
    "callingCode": "690",
    "code": "TK",
    "name": "Tokelau",
  },
  {
    "callingCode": "993",
    "code": "TM",
    "name": "Turkmenistan",
  },
  {
    "callingCode": "670",
    "code": "TL",
    "name": "Timor-Leste",
  },
  {
    "callingCode": "676",
    "code": "TO",
    "name": "Tonga",
  },
  {
    "callingCode": "1868",
    "code": "TT",
    "name": "Trinidad and Tobago",
  },
  {
    "callingCode": "216",
    "code": "TN",
    "name": "Tunisia",
  },
  {
    "callingCode": "90",
    "code": "TR",
    "name": "Turkey",
  },
  {
    "callingCode": "688",
    "code": "TV",
    "name": "Tuvalu",
  },
  {
    "callingCode": "886",
    "code": "TW",
    "name": "Taiwan",
  },
  {
    "callingCode": "255",
    "code": "TZ",
    "name": "Tanzania",
  },
  {
    "callingCode": "256",
    "code": "UG",
    "name": "Uganda",
  },
  {
    "callingCode": "380",
    "code": "UA",
    "name": "Ukraine",
  },
  {
    "callingCode": "598",
    "code": "UY",
    "name": "Uruguay",
  },
  {
    "callingCode": "998",
    "code": "UZ",
    "name": "Uzbekistan",
  },
  // {
  //   "callingCode": "3906698",
  //   "code": "VA",
  //   "flag": "🇻🇦",
  //   "name": "Vatican City",
  // },
  {
    "callingCode": "1784",
    "code": "VC",
    "name": "Saint Vincent and the Grenadines",
  },
  {
    "callingCode": "58",
    "code": "VE",
    "name": "Venezuela",
  },
  {
    "callingCode": "1284",
    "code": "VG",
    "name": "British Virgin Islands",
  },
  {
    "callingCode": "1340",
    "code": "VI",
    "name": "United States Virgin Islands",
  },
  {
    "callingCode": "84",
    "code": "VN",
    "name": "Vietnam",
  },
  {
    "callingCode": "678",
    "code": "VU",
    "name": "Vanuatu",
  },
  {
    "callingCode": "681",
    "code": "WF",
    "name": "Wallis and Futuna",
  },
  {
    "callingCode": "685",
    "code": "WS",
    "name": "Samoa",
  },
  {
    "callingCode": "967",
    "code": "YE",
    "name": "Yemen",
  },
  {
    "callingCode": "27",
    "code": "ZA",
    "name": "South Africa",
  },
  {
    "callingCode": "260",
    "code": "ZM",
    "name": "Zambia",
  },
  {
    "callingCode": "263",
    "code": "ZW",
    "name": "Zimbabwe",
  }
]